import { copyListFormStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsCopyListForm";

copyListFormStyles.container = {
    ...copyListFormStyles.container,

    gap: 10,
};
